import React, { useState } from "react";
import { ActionIcon, Tooltip } from "@mantine/core";
import {
  CHROME_TOOLBAR_ICON_GLYPH,
  chromeToolbarIconButtonProps,
} from "../utils/editorChromeTheme";

/**
 * Single icon control in the editor top bar — consistent hit target, hover, and glyph size.
 */
export default function EditorToolbarIcon({
  label,
  onClick,
  disabled = false,
  iconColour,
  inGroup = false,
  children,
  iconSize = CHROME_TOOLBAR_ICON_GLYPH,
  ...actionIconProps
}) {
  const [hover, setHover] = useState(false);

  const button = (
    <ActionIcon
      disabled={disabled}
      onClick={onClick}
      onPointerOver={() => setHover(true)}
      onPointerLeave={() => setHover(false)}
      {...chromeToolbarIconButtonProps(hover, iconColour, disabled, inGroup)}
      {...actionIconProps}
    >
      {children}
    </ActionIcon>
  );

  if (!label) return button;
  return <Tooltip label={label}>{button}</Tooltip>;
}
